import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeFormComponent } from '../../components/employee-form/employee-form.component';
import { CreateEmployeeRequest } from '../../employee.model';
import { ClientStore } from '@features/client/client.store';
import { EmployeeStore } from '../../employee.store';
import { LookupStore } from '@core/lookup/lookup.store';import { EMPLOYEE_LOOKUP_CODES } from '@core/lookup/lookup-codes';

import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";

@Component({
  selector: 'app-employee-create-page',
  imports: [EmployeeFormComponent, ...SHARED_IMPORTS],
  templateUrl: './employee-create.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EmployeeCreatePage {
  protected readonly clientStore = inject(ClientStore);
  protected readonly employeeStore = inject(EmployeeStore);
  protected readonly lookupStore = inject(LookupStore);
  private selectedClientId: string | null = null;
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  constructor() {
    this.lookupStore.load(EMPLOYEE_LOOKUP_CODES);
    this.clientStore.loadClients({ includeInactive: false });
    this.employeeStore.loadManagerLookupResponses();
  }

  protected createEmployee(request: CreateEmployeeRequest): void {
    this.employeeStore.createEmployee(request, (employee) => {
      void this.router.navigate(['/employees', employee.id], {
        queryParams: { clientId: employee.clientId },
      });
    });
  }

  protected onClientChanged(clientId: string | null): void {
    this.selectedClientId = clientId;
    this.clientStore.selectClient(clientId);
    this.employeeStore.loadCompanies(clientId);
    this.employeeStore.loadManagerLookupResponses();
    this.clientStore.filterClientCompanies(clientId, null);
  }

  protected onCompanyChanged(companyId: string | null): void {
    this.employeeStore.loadCompanyDetails(companyId);
    this.employeeStore.loadManagerLookupResponses();
    this.clientStore.filterClientCompanies(this.selectedClientId, companyId);
  }

  protected onManagerLookupSearchChanged(searchTerm: string): void {
    this.employeeStore.loadManagerLookupResponses(searchTerm);
  }
}
